export default __webpack_public_path__ + "aba179ee6260784363051c5399b4135b.svg";